import { c as _c } from "react/compiler-runtime";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { SkeletonProjectListItemCard } from "@components/common/mobile/skeleton-project-list-item-card";
import { ProjectListItemCardMobile } from "@components/project/project-list-item-card-mobile";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { Box } from "@mui-wrapper";
import { useProjectMenuOptions } from "@pages/projects/use-project-menu-options";
import { generateProjectDetailsRoute } from "@router/router-helper";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useProjectsPageBulkActions } from "@pages/projects/use-projects-page-bulk-actions";
/**
 * Mobile-specific view for projects list with action bar (search, sort, export) and card layout.
 */
export function ProjectsMobileView(t0) {
  const $ = _c(26);
  const {
    projects,
    sortBy,
    isLoading,
    projectArchivingState,
    loadMoreProjects
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      contextType: "projects-menu-option-mobile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const menuItems = useProjectMenuOptions(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("projects");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedEntities = useAppSelector(t2);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const t3 = selectedSdbCompany?.id ?? "";
  let t4;
  if ($[2] !== projectArchivingState || $[3] !== projects || $[4] !== t3) {
    t4 = {
      companyId: t3,
      projects,
      projectStatus: projectArchivingState,
      subjectType: "workspace"
    };
    $[2] = projectArchivingState;
    $[3] = projects;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const bulkActionsButtons = useProjectsPageBulkActions(t4);
  if (!selectedSdbCompany) {
    return null;
  }
  let t5;
  if ($[6] !== projects) {
    t5 = projects.map(_temp);
    $[6] = projects;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const allProjectIds = t5;
  let t6;
  if ($[8] !== menuItems || $[9] !== selectedSdbCompany.id || $[10] !== sortBy) {
    t6 = project_0 => <Box key={project_0.id}><ProjectListItemCardMobile project={project_0} sortBy={sortBy} contextType="projects-menu-option-mobile" href={generateProjectDetailsRoute(selectedSdbCompany.id, project_0.id)} menuItems={menuItems} /></Box>;
    $[8] = menuItems;
    $[9] = selectedSdbCompany.id;
    $[10] = sortBy;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isLoading || $[13] !== loadMoreProjects || $[14] !== projects || $[15] !== sortBy || $[16] !== t6) {
    t7 = <VirtualizedGrid key={sortBy} items={projects} isLoading={isLoading} loadMoreItems={loadMoreProjects} renderSkeletonItem={_temp2} estimateSize={112} renderItem={t6} />;
    $[12] = isLoading;
    $[13] = loadMoreProjects;
    $[14] = projects;
    $[15] = sortBy;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== allProjectIds || $[19] !== bulkActionsButtons || $[20] !== isLoading || $[21] !== selectedEntities.length) {
    t8 = <FaroTableBulkActions bulkActionsButtons={bulkActionsButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allProjectIds} />;
    $[18] = allProjectIds;
    $[19] = bulkActionsButtons;
    $[20] = isLoading;
    $[21] = selectedEntities.length;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp2(index) {
  return <Box key={index}><SkeletonProjectListItemCard /></Box>;
}
function _temp(project) {
  return project.id;
}